import { render, staticRenderFns } from "./CatalogProductSelector.vue?vue&type=template&id=27141bce&scoped=true&"
import script from "./CatalogProductSelector.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSelector.vue?vue&type=style&index=0&id=27141bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27141bce",
  null
  
)

export default component.exports